import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CapitalizePipe } from './capitalize.pipe';
import { FormattedCelPipe } from './formatted-cel.pipe';
import { FormattedCepPipe } from './formatted-cep.pipe';
import { FormattedCnpjPipe } from './formatted-cnpj.pipe';
import { FormattedCpfPipe } from './formatted-cpf.pipe';
import { FormattedMapaSipeagroPipe } from './formatted-mapa-sipeagro.pipe';
import { FormattedTelPipe } from './formatted-tel.pipe';
import { IsCompleteNamePipe } from './is-complete-name-pipe.pipe';
import { IsCpfPipe } from './is-cpf.pipe';
import { IsTelPipe } from './is-tel.pipe';
import { OnlyNumbersPipe } from './only-numbers.pipe';
import { SafePipe } from './safe.pipe';
import { ToJsonPipe } from './to-json.pipe';
import { WithLoadingPipe } from './with-loading.pipe';
import { SexPetParsedPipe } from './sex-pet-parserd.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [
    IsCompleteNamePipe,
    FormattedTelPipe,
    FormattedCelPipe,
    IsTelPipe,
    OnlyNumbersPipe,
    IsCpfPipe,
    FormattedCepPipe,
    FormattedCpfPipe,
    FormattedCnpjPipe,
    SafePipe,
    ToJsonPipe,
    FormattedMapaSipeagroPipe,
    CapitalizePipe,
    WithLoadingPipe,
    SexPetParsedPipe
  ],
  exports: [
    IsCompleteNamePipe,
    FormattedTelPipe,
    FormattedCelPipe,
    IsTelPipe,
    OnlyNumbersPipe,
    IsCpfPipe,
    FormattedCepPipe,
    FormattedCpfPipe,
    FormattedCnpjPipe,
    SafePipe,
    ToJsonPipe,
    FormattedMapaSipeagroPipe,
    CapitalizePipe,
    WithLoadingPipe,
    SexPetParsedPipe
  ]
})
export class PipesModule {}
